export default "__VITE_ASSET__BhmORu3Q__"